// 接口引入
import {
  PurchaseAndSeven,
} from '@/api/purchaseAndSaleAPI'
import selectOptionDict from '@/store/dict/selectOptionDict'

export default function (data) {
  const { dealWithData, tabNo, bizType } = data

  // 处理搜索数据
  const dealWithSearch = (params) => {
    // 时间处理
    if (dealWithData) dealWithData(params)
    // 订单创建时间
    if (params.TheOrderStart && params.TheOrderStart.length > 0) {
      params.createTimeStart = params.TheOrderStart[0]
      params.createTimeEnd = params.TheOrderStart[1]
    } else {
      delete params.createTimeStart
      delete params.createTimeEnd
      delete params.TheOrderStart
    }
    // 订单确认时间
    if (params.TheOrderconfirmtime && params.TheOrderconfirmtime.length > 0) {
      params.confirmTimeStart = params.TheOrderconfirmtime[0]
      params.confirmTimeEnd = params.TheOrderconfirmtime[1]
    } else {
      delete params.confirmTimeStart
      delete params.confirmTimeEnd
      delete params.TheOrderconfirmtime
    }
    // 发车验车时间
    if (params.TheCarExTime && params.TheCarExTime.length > 0) {
      params.outStockTimeStart = params.TheCarExTime[0]
      params.outStockTimeEnd = params.TheCarExTime[1]
    } else {
      delete params.outStockTimeStart
      delete params.outStockTimeEnd
      delete params.TheCarExTime
    }
    // 计租结束日时间
    if (params.rentFinIsh && params.rentFinIsh.length > 0) {
      params.rentEndTimeStart = params.rentFinIsh[0]
      params.rentEndTimeEnd = params.rentFinIsh[1]
    } else {
      delete params.rentEndTimeStart
      delete params.rentEndTimeEnd
      delete params.rentFinIsh
    }
    // 退车验车时间
    if (params.TheCarinStockTime && params.TheCarinStockTime.length > 0) {
      params.inStockTimeStart = params.TheCarinStockTime[0]
      params.inStockTimeEnd = params.TheCarinStockTime[1]
    } else {
      delete params.closeTimeStart
      delete params.inStockTimeEnd
      delete params.TheCarinStockTime
    }
    // 退车解约时间
    if (params.TheOrderCloseTime && params.TheOrderCloseTime.length > 0) {
      params.closeTimeStart = params.TheOrderCloseTime[0]
      params.closeTimeEnd = params.TheOrderCloseTime[1]
    } else {
      delete params.closeTimeStart
      delete params.closeTimeEnd
      delete params.TheOrderCloseTime
    }
    // 免租结束日时间
    if (params.freeCycleEndTime && params.freeCycleEndTime.length > 0) {
      params.presentEntTimeStart = params.freeCycleEndTime[0]
      params.presentEntTimeEnd = params.freeCycleEndTime[1]
    } else {
      delete params.presentEntTimeStart
      delete params.presentEntTimeEnd
      delete params.freeCycleEndTime
    }
    // 品牌车系车型
    const { brandSeriesModel } = params
    const brandId = brandSeriesModel?.brandId
    const seriesId = brandSeriesModel?.seriesId
    const modelId = brandSeriesModel?.modelId
    delete params.brandSeriesModel
    return {
      ...params,
      tabNo,
      bizType, // 常量
      brandId,
      seriesId,
      modelId,
    }
  }

  const configData = {
    formData: {
      list: [
        {
          el: 'select',
          itemConfig: {
            label: '关联订单原因',
            prop: 'relatedType',
          },
          elConfig: {
            placeholder: '请选择关联订单原因',
            options: {
              label: 'label',
              value: 'value',
              list: [
                { label: '全部', value: '' },
                ...this.dictParseList(selectOptionDict.rderRelatedReason),
              ],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '合同签署状态',
            prop: 'contractState',
          },
          elConfig: {
            placeholder: '请选择合同签署状态',
            options: {
              label: 'label',
              value: 'value',
              list: [
                { label: '全部', value: '' },
                // 去除审批中状态
                ...this.dictParseList(selectOptionDict.leaseOrderContractState).filter((item) => item.value !== 8),
              ],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '网约钱包支付签约状态',
            prop: 'walletWithholdState',
          },
          elConfig: {
            placeholder: '请选择网约钱包支付签约状态',
            options: {
              label: 'label',
              value: 'value',
              list: [
                { label: '全部', value: '' },
                ...this.dictParseList(selectOptionDict.walletWithholdState),
              ],
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '订单创建时间',
            prop: 'TheOrderStart',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '订单确认时间',
            prop: 'TheOrderconfirmtime',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',

          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '发车验车时间',
            prop: 'TheCarExTime',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',

          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '计租结束日',
            prop: 'rentFinIsh',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',

          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '退车验车时间',
            prop: 'TheCarinStockTime',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '退车解约时间',
            prop: 'TheOrderCloseTime',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '免租结束日',
            prop: 'freeCycleEndTime',
          },
          elConfig: {
            'prefix-icon': 'el-icon-date',
          },
        },
      ],
      dealWithSearch,
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '订单ID',
            fixed: 'left',
            width: '110',
          },
          render: ({ row }) => {
            return this.$createElement(
              'div', [this.$createElement('span', {
                class: 'orderId',

              }, [row.id])],
            )
          },
        },
        {
          name: 'customerName',
          columnProps: {
            prop: 'customerName',
            label: '客户名称',
            width: 110,
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '订单创建时间',
            width: '160',
          },
        },
        {
          name: 'contractState',
          columnProps: {
            label: '合同签署状态',
            width: '110',
            formatter: (row) =>
              selectOptionDict.leaseOrderContractState[row.contractState],
          },
        },
        {
          name: 'rentAmount',
          columnProps: {
            label: '每期租金(元)',
            width: '110',
            formatter: (row) => {
              const { orderConfig } = row
              const { piecewiseCalculation } = orderConfig || {}
              const { isOpen = 0 } = piecewiseCalculation || {}
              // 阶梯方案 展示'--'
              if (orderConfig && Number(isOpen) === 1) {
                return '--'
              }
              return row.rentAmount
            },
          },
        },
        {
          name: 'walletWithholdState',
          columnProps: {
            width: '110',
            label: '网约钱包支付',
          },
          render: ({ row }) => {
            if (row.withholdVersion === 2) {
              return this.$createElement('div', {}, [
                row.dayAndWeekWalletWithhold?.status !== undefined &&
                row.dayAndWeekWalletWithhold?.status !== null
                  ? selectOptionDict.walletWithholdState[
                    row.dayAndWeekWalletWithhold?.status
                  ]
                  : '--',
                row.dayAndWeekWalletWithhold?.noOpenReason &&
                  this.$createElement('el-tooltip', { props: { placement: 'top-start' } }, [
                    this.$createElement('div', { slot: 'content' }, [
                      row.dayAndWeekWalletWithhold.noOpenReason,
                    ]),
                    this.$createElement('i', { class: 'el-icon-question' }),
                  ]),
              ])
            }
            return this.$createElement('div', {}, [
              row.walletWithholdState.signState !== undefined &&
              row.walletWithholdState.signState !== null
                ? selectOptionDict.walletWithholdState[
                  row.walletWithholdState.signState
                ]
                : '--',
            ])
          },
        },
        {
          name: 'personalWithholdState',
          columnProps: {
            width: '100',
            label: '支付宝支付',
          },
          render: ({ row }) => {
            const { reason, signState } = row.personalWithholdState || {}
            const parseReason = reason ? JSON.parse(reason) : []
            return this.$createElement(
              'div',
              [
                selectOptionDict.alipayWithholdStateNew[signState] || '--',
                // 判断是否有提示文字
                reason
                  ?
                  this.$createElement(
                    'el-tooltip',
                    {
                      props: {
                        placement: 'top-start',
                        effect: 'dark',
                      },
                    },
                    [
                      this.$createElement('i', { class: 'el-icon-question' }),
                      this.$createElement('div', {
                        slot: 'content',
                      },
                      [
                        parseReason.map((item) => this.$createElement('p', item)),
                      ]),
                    ],
                  ) : '',
              ],
            )
          },
        },
        {
          name: 'deposit',
          columnProps: {
            label: '总押金/已收',
            width: '150',
            align: 'left',
            formatter: (row) =>
              `${row.deposit === null ? '0.00' : row.deposit}` +
                '/' +
                `${row.receivedDeposit}`,
          },
        },
        {
          name: 'confirmTime',
          columnProps: {
            prop: 'confirmTime',
            label: '订单确认时间',
            width: '160',
          },
        },
        {
          name: 'outStockTime',
          columnProps: {
            prop: 'outStockTime',
            label: '发车验车时间',
            width: '160',
          },
        },
        {
          name: 'startDate',
          columnProps: {
            prop: 'startDate',
            label: '计租开始日',
            width: '100',
          },
        },
        {
          name: 'endDate',
          columnProps: {
            prop: 'endDate',
            label: '计租结束日',
            width: '100',
          },
        },
        {
          name: 'presentEntDate',
          columnProps: {
            prop: 'presentEntDate',
            label: '免租结束日',
            width: '100',
          },
        },
        {
          name: 'inStockTime',
          columnProps: {
            prop: 'inStockTime',
            label: '退车验车时间',
            width: '160',
          },
        },
        {
          name: 'closeTime',
          columnProps: {
            prop: 'closeTime',
            label: '退车解约时间',
            width: '160',
          },
        },
        {
          name: 'closeType',
          columnProps: {
            label: '退车解约原因',
            width: '110',
            formatter: (row) => selectOptionDict.closingReason[row.closeType],
          },
        },
        {
          name: 'settlementState',
          columnProps: {
            label: '结算状态',
            formatter: (row) =>
              selectOptionDict.settlementForm[row.settlementState],
          },
        },
        {
          name: 'state',
          columnProps: {
            label: '订单状态',
            width: '100',
            formatter: (row) => selectOptionDict.leaseOrderState[row.state],
          },
        },
        {
          name: 'relatedType',
          columnProps: {
            label: '关联原因',
            width: 110,
            formatter: (row) =>
              selectOptionDict.rderRelatedReason[row.relatedType],
          },
        },
        {
          name: 'createUser',
          columnProps: {
            prop: 'createUser',
            width: '110',
            label: '订单创建人',
          },
        },
      ],
      apiFn: PurchaseAndSeven,
    },
  }

  return {
    configData,
  }
}
